import { render, staticRenderFns } from "./AllergiesFilter.vue?vue&type=template&id=98b4873a"
import script from "./AllergiesFilter.vue?vue&type=script&lang=js"
export * from "./AllergiesFilter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports